import { DeleteRounded, DesignServices, DownloadRounded, InfoRounded, Publish } from "@mui/icons-material";
import { Box, Button, IconButton, Typography } from "@mui/material";
import { blue, yellow } from "@mui/material/colors";
import { rootProtectedPath, services } from "data/authData";
import DashboardNavCollapsableWithCustomNav from "components/Layout/DashboardNavCollapsableWithCustomNav/DashboardNavCollapsableWithCustomNav";
import { Navigate, Route } from "react-router-dom";
import PimDashboard from "components/PimDashboard/PimDashboard";

import {
	arrType,
	booleaStrOptions,
	datatypes,
	inputTypes,
	objType,
	publishColumns,
	PimDashboardServices,
	selectOptionsKeyName,
	statusOptions,
} from "data/globalData";

import moment from "moment";
import { pimDashboardMeta } from "data/pimData";
import StudioDashboardProvider from "context/StudioDashboardContext";
import BuyingDashboardProvider from "context/BuyingDashboardContext";

export const serviceContextMap = {
	[PimDashboardServices.studio.key]: <StudioDashboardProvider />,
	[PimDashboardServices.buying.key]: <BuyingDashboardProvider />,
};
export const generatePimRoutesFromServiceTree = (service, rootPath) => {
	if (service?.types) {
		const defaultRoute = Object.values(service.types)[0];

		console.log(defaultRoute, rootPath, service, "sdmnfbskdnkasdas");
		let rest = {};
		// for context
		if (serviceContextMap[service.key]) rest = { ...rest, element: serviceContextMap[service.key] };
		return (
			<Route key={service.key} path={service.key} {...rest}>
				<Route index element={<Navigate to={defaultRoute.key} />} />
				{service.types &&
					Object.keys(service.types).map((childKey) => generatePimRoutesFromServiceTree(service.types[childKey], rootPath))}
			</Route>
		);
	} else
		return (
			<Route
				key={service.key}
				path={service.key}
				element={
					<DashboardNavCollapsableWithCustomNav
						drawerList={PimDashboardServices}
						searchParamName="tab"
						navSpace={0}
						service={service}
						pathName={service.key}
						rootPath={rootPath}
						baseUrl={rootProtectedPath}
						dashboardMeta={pimDashboardMeta}
					/>
				}>
				<Route index element={<PimDashboard />} />
			</Route>
		);
};

export const attributeCollectionTypes = {
	STYLES: { name: "STYLES", key: "STYLES" },
	SHOOTS: { name: "SHOOTS", key: "SHOOTS" },
	MODAL_PROFILES: { name: "MODAL PROFILES", key: "MODAL_PROFILES" },
};
export const styleColorAssocObj = "styleColor";
export const styleImagesAssocObj = "styleImages";
export const colorImagesAssocObj = "colorImages";
export const styleFileAssocObj = "styleFiles";

export const productPagePath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.designer.key}/${PimDashboardServices.designer.types.selected_style.key}`;
export const selectedBuyPagePath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.buying.key}/${PimDashboardServices.buying.types.selected_buying.key}`;
export const allStylesPath = `${rootProtectedPath}/${PimDashboardServices.designer.types.styles.key}`;
export const buyingSheetPath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.buying.key}`;
export const pimDashboardPath = `${rootProtectedPath}/${pimDashboardMeta.path}`;
export const selectedModalProfilePagepath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.studio.key}/${PimDashboardServices.studio.types.modal_profiles.key}/${PimDashboardServices.studio.types.modal_profiles.types.selected_modal_profile.key}`;
export const selectedShootPagepath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.studio.key}/${PimDashboardServices.studio.types.selected_shoot.key}`;
export const selectedShootCostingPagepath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.studio.key}/${PimDashboardServices.studio.types.shoot_costing.key}/${PimDashboardServices.studio.types.shoot_costing.types.selected_shoot_costing.key}`;
export const allShootspath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.studio.key}/${PimDashboardServices.studio.types.all_shoots.key}`;
export const selectedOpenCostingPath = `${rootProtectedPath}/${pimDashboardMeta.path}/${PimDashboardServices.sourcing.key}/${PimDashboardServices.sourcing.types.open_costing.key}/${PimDashboardServices.sourcing.types.open_costing.types.selected_open_costing.key}`;

export const productionStageOptions = {
	DESIGNER: { name: "Designer", color: blue[300], key: "DESIGNER", icon: <DesignServices /> },
	BUYING: { name: "Buying", color: yellow[300], key: "BUYING", icon: <DesignServices /> },
	FABRIC_TRIMS: { name: "Fabric & Trims", color: yellow[300], key: "FABRIC_TRIMS", icon: <DesignServices /> },
	SOURCING: { name: "Sourcing", color: yellow[300], key: "SOURCING", icon: <DesignServices /> },
};
export const colorProductionStageOptions = {
	BUYING: { name: "Buying", key: "BUYING" },
	SOURCING: { name: "Sourcing", key: "SOURCING" },
	COMPLETED: { name: "Completed", key: "COMPLETED" },
	FOB_PO: { name: "FOB PO", key: "FOB_PO" },
};

export const attrTableStrColumnsObj = {
	name: {
		name: "Name",
		key: "name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, display: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	key: {
		name: "Key",
		key: "key",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 1,
	},
	input_type: {
		name: "Input Type",
		key: "input_type",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.STRING.key,
		data: {},
		sort_no: 2,
		[selectOptionsKeyName]: { type: objType, list: inputTypes },
	},
	data_type: {
		name: "Data Type",
		key: "data_type",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.STRING.key,
		data: {},
		dependency: { input_type: true },
		sort_no: 3,

		[selectOptionsKeyName]: { type: arrType, list: Object.keys(datatypes)?.map((row) => datatypes[row]) },
	},
	sort_no: {
		name: "Sort No",
		key: "sort_no",
		input_type: inputTypes.AUTO_GENERATE.key,
		sort_no: 4,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.NUMBER.key,
		data: {},
	},
	default_value: {
		name: "Default Value",
		key: "default_value",
		input_type: inputTypes.ENTER.key,
		sort_no: 5,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.STRING.key,
		data: {},
	},
	collection_type: {
		name: "Collection Type",
		key: "collection_type",
		input_type: inputTypes.AUTO_GENERATE.key,
		sort_no: 5,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.STRING.key,
		data: {},
	},
};
export const attrValTableStrColumnsObj = {
	value: {
		name: "Value",
		key: "value",
		input_type: inputTypes.ENTER.key,
		constraints: { notNull: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	dependency: {
		name: "Dependency",
		key: "dependency",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { notNull: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.JSON.key,
		sort_no: 1,
	},
};

export const attrGroupLinkedTables = {
	// sync with backend data
	style: { name: "Style", key: "style", sqlTable: "style", seqMethod: "StyleModal" },
	color: { name: "Color", key: "color", sqlTable: "color", seqMethod: "ColorModal" },
	style_details: { name: "Style Details", key: "style_details", sqlTable: "style_details", seqMethod: "StyleDetails" },
};

export const attrGrpTableStrColumnsObj = {
	group_id: {
		name: "Group Id",
		key: "group_id",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.NUMBER.key,
		sort_no: 1,
	},

	name: {
		name: "Name",
		key: "name",
		input_type: inputTypes.ENTER.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 0,
	},
	linked_table: {
		name: "Linked Table",
		key: "linked_table",
		input_type: inputTypes.SELECT.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data: {},
		data_type: datatypes.STRING.key,
		sort_no: 2,
		[selectOptionsKeyName]: { type: objType, list: attrGroupLinkedTables },
		value_getter: (feild, row) => {
			return attrGroupLinkedTables[row[feild]].name;
		},
	},
	sort_no: {
		name: "Sort No",
		key: "sort_no",
		input_type: inputTypes.ENTER.key,
		sort_no: 4,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.NUMBER.key,

		data: {},
	},
	collection_type: {
		name: "Collection Type",
		key: "collection_type",
		input_type: inputTypes.AUTO_GENERATE.key,
		sort_no: 5,
		constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
		data_type: datatypes.STRING.key,
		data: {},
	},
	is_main: {
		name: "Is main",
		key: "is_main",
		input_type: inputTypes.AUTO_GENERATE.key,
		constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: true },
		data: {},
		data_type: datatypes.BOOLEAN.key,
		sort_no: 1,
	},
};
export const attrConditionalDisplayColObj = {
	name: "Trigger Attribute",
	key: "attr_display_trigger",
	input_type: inputTypes.MULTIPLE_SELECT.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 0,
};
export const startDateColumn = {
	name: "Start Date",
	key: "start_date",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DATE.key,
	sort_no: 0,
};
export const endDateColumn = {
	name: "End Date",
	key: "end_date",
	input_type: inputTypes.ENTER.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.DATE.key,
	sort_no: 0,
};
export const autoUpdateColData = {
	[attrTableStrColumnsObj.name.key]: {
		col: attrTableStrColumnsObj.key,
		val: (triggerCol, triggerColVal, colToUpdate, options) => triggerColVal?.split(" ").join("_").toLowerCase(),
	},
};
export const autoUpdateGroupCol = {
	[attrGrpTableStrColumnsObj.name.key]: {
		col: attrGrpTableStrColumnsObj.group_id,
		val: (triggerCol, triggerColVal, colToUpdate, options) => triggerColVal?.split(" ").join("_").toLowerCase(),
	},
};
export const attributGrpColObj = {
	name: "Group",
	key: "group_id",
	input_type: inputTypes.AUTO_GENERATE.key,
	constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
	data: {},
	data_type: datatypes.STRING.key,
	sort_no: 0,
};
export const dependencyAttrColObj = { name: "Dependency", key: "dependency" };

export const constraintsOptions = {
	UNIQUE: { name: "Unique", key: "UNIQUE", editable: false, sql_val: "UNIQUE" },
	NOTNULL: { name: "REQUIRED", key: "NOTNULL", editable: true, sql_val: "NOT NULL" },
	DISPLAY: { name: "Display", key: "DISPLAY", editable: true },
};

export const constraintsAttrColObj = {
	name: "Constraints",
	key: "constraints",
	input_type: inputTypes.SELECT.key,
	option_data: { type: objType, list: constraintsOptions },
};
export const addOrEditModelAction = { UPDATE: "UPDATE", CREATE: "CREATE" };

export const getColDefaultValue = (col, disableUserDefaultValue = false) => {
	if (!disableUserDefaultValue && col?.default_value) {
		if (col?.input_type === inputTypes.MULTIPLE_SELECT.key) return [col?.default_value];
		else return col?.default_value;
	}
	if (col?.input_type === inputTypes.ENTER.key) {
		return col?.data_type === datatypes.STRING.key
			? ""
			: col?.data_type === datatypes.NUMBER.key
				? 0
				: col?.data_type === datatypes.DECIMAL.key
					? 0.0
					: "";
	} else if (col?.input_type === inputTypes.SELECT.key) {
		return col?.data_type === datatypes.BOOLEAN.key ? booleaStrOptions.NO.key : "";
	} else if (col?.input_type === inputTypes.MULTIPLE_SELECT.key) return [];

	return "";
};
export const formatColumnValue = (value, col) => {
	if (col?.input_type === inputTypes.ENTER.key) {
		if (col?.data_type === datatypes.STRING.key) return value ? value : "";
		else if (col?.data_type === datatypes.NUMBER.key) return value ?? 0;
		else if (col?.data_type === datatypes.DECIMAL.key) return value ?? 0;
	} else if (col?.input_type === inputTypes.SELECT.key) {
		if (col?.data_type === datatypes.BOOLEAN.key) return ["YES"]?.includes(value) ? "YES" : "NO";
		else return value ? value : "";
	} else if (col?.input_type === inputTypes.MULTIPLE_SELECT.key) return value?.length ? `${value.map((row) => `${row}, `)}` : "";
	else if (col?.data_type === datatypes.DATE.key) return value ? moment(value).format("DD/MM/YYYY") : null;

	return value ? value : "";
};
// only difference is for number and decimal we are converting to number using +ve operator
export const setColumnValueBasedOnType = (col, value) => {
	if (col?.input_type === inputTypes.ENTER.key) {
		if (col?.data_type === datatypes.STRING.key) return value ? value : "";
		else if (col?.data_type === datatypes.NUMBER.key) return +value ?? 0;
		else if (col?.data_type === datatypes.DECIMAL.key) return +value ?? 0.0;
	} else if (col?.input_type === inputTypes.SELECT.key) {
		if (col?.data_type === datatypes.BOOLEAN.key) return ["YES"]?.includes(value) ? "YES" : "NO";
		else return value ? value : "";
	} else if (col?.input_type === inputTypes.MULTIPLE_SELECT.key) return Array.isArray(value) ? value : [];
	else if (col?.data_type === datatypes.DATE.key) return value ? value : null;
	return value ? value : "";
};
export const isColumnDefault = (col, value) => {
	if (Array.isArray(value)) return value?.length ? false : true;
	if (value === getColDefaultValue(col, true) || !value) return true;
	else return false;
};

export const publishTableColumn = (publishFun = () => {}, disableBtn = false) => {
	return {
		headerName: publishColumns.status.name,
		field: publishColumns.status.key,
		minWidth: 98,
		headerAlign: "center",
		align: "center",
		flex: 1,

		renderCell: ({ row }) => {
			const disableBtnVal = typeof disableBtn === "function" ? disableBtn({ row }) : disableBtn;
			if ([statusOptions.PUBLISHED.key, statusOptions.REJECTED.key]?.includes(row?.[publishColumns.status.key]))
				return (
					<Box display="flex" maxWidth="100%" height="100%" alignItems="center" justifyContent="center">
						<Box
							display="flex"
							width="100%"
							alignItems="center"
							height={"22px"}
							// columnGap={1}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "6px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}
							<Typography pl="3px" width="100%" overflow="hidden" textOverflow="ellipsis">
								{statusOptions[row.status]?.name ?? "----"}
							</Typography>
						</Box>
					</Box>
				);
			else if (disableBtnVal)
				return (
					<Box display="flex" width="100%" height="100%" alignItems="center" justifyContent="center">
						<Box
							display="flex"
							alignItems="center"
							height={"22px"}
							// columnGap={1}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "6px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}{" "}
							<Typography pl="3px"> {statusOptions[row.status]?.name ?? "----"}</Typography>
						</Box>
					</Box>
				);
			else
				return (
					<Button
						onClick={(e) => publishFun(e, row)}
						variant="contained"
						size="small"
						sx={{ textTransform: "capitalize" }}
						startIcon={<Publish />}>
						Publish
					</Button>
				);
		},
	};
};

export const publishWithRemarksColumn = (publishFun = () => {}, disableBtn = false, onRemarkClick = () => {}) => {
	return {
		headerName: "Status",
		field: publishColumns.status.key,
		minWidth: 150,
		headerAlign: "center",
		align: "center",
		flex: 1,
		renderCell: ({ row }) => {
			const disableBtnVal = typeof disableBtn === "function" ? disableBtn({ row }) : disableBtn;
			const hasRemark = !!row.remark_id;

			if ([statusOptions.PUBLISHED.key, statusOptions.REJECTED.key]?.includes(row?.[publishColumns.status.key]))
				return (
					<Box display="flex" height="100%" alignItems="center" justifyContent="center" columnGap={0.5}>
						{hasRemark && (
							<IconButton
								onClick={(e) => {
									e.stopPropagation();
									onRemarkClick(e, row);
								}}
								size="small"
								color="warning"
								sx={{ p: 0.5 }}>
								<InfoRounded fontSize="small" />
							</IconButton>
						)}
						<Box
							display="flex"
							alignItems="center"
							height={"22px"}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "4px 8px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}
							<Typography pl="3px" fontSize="12px" noWrap>
								{statusOptions[row.status]?.name ?? "----"}
							</Typography>
						</Box>
					</Box>
				);
			else if (disableBtnVal)
				return (
					<Box display="flex" height="100%" alignItems="center" justifyContent="center" columnGap={0.5}>
						{hasRemark && (
							<IconButton
								onClick={(e) => {
									e.stopPropagation();
									onRemarkClick(e, row);
								}}
								size="small"
								color="warning"
								sx={{ p: 0.5 }}>
								<InfoRounded fontSize="small" />
							</IconButton>
						)}
						<Box
							display="flex"
							alignItems="center"
							height={"22px"}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "4px 8px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}
							<Typography pl="3px" fontSize="12px" noWrap>
								{statusOptions[row.status]?.name ?? "----"}
							</Typography>
						</Box>
					</Box>
				);
			else
				return (
					<Box display="flex" alignItems="center" justifyContent="center" columnGap={0.5} height="100%">
						<Button
							onClick={(e) => {
								e.stopPropagation();
								publishFun(e, row);
							}}
							variant="contained"
							size="small"
							sx={{ textTransform: "capitalize", fontSize: "11px" }}
							startIcon={<Publish fontSize="small" />}>
							Publish
						</Button>
					</Box>
				);
		},
	};
};

export const downLoadTableColumn = (publishFun = () => {}, disableBtn = false) => {
	return {
		headerName: "Download",
		field: "download",
		minWidth: 98,
		headerAlign: "center",
		align: "center",
		flex: 1,
		renderCell: ({ row }) => {
			return (
				<IconButton onClick={(e) => publishFun(e, row)} variant="contained" size="small" sx={{ textTransform: "capitalize" }}>
					<DownloadRounded />
				</IconButton>
			);
		},
	};
};
export const deleteColumn = (deleteFun = () => {}, disableBtn = false) => {
	return {
		headerName: "DELETE",
		field: "delete",
		width: 150,
		headerAlign: "center",
		align: "center",
		renderCell: ({ row }) => {
			return (
				<Box display="flex" justifyContent="center" alignItems="center">
					<IconButton variant="contained" color="error" disabled={disableBtn} onClick={() => deleteFun(row)}>
						<DeleteRounded />
					</IconButton>
				</Box>
			);
		},
	};
};

export const remarkTableColumn = (onRemarkClick = () => {}, publishFun = () => {}, disableBtn = false) => {
	return {
		headerName: "Status",
		field: publishColumns.status.key,
		minWidth: 120,
		headerAlign: "center",
		align: "center",
		flex: 1,
		renderCell: ({ row }) => {
			const disableBtnVal = typeof disableBtn === "function" ? disableBtn({ row }) : disableBtn;
			const hasRemark = !!row.remark_id;

			if ([statusOptions.PUBLISHED.key, statusOptions.REJECTED.key]?.includes(row?.[publishColumns.status.key]))
				return (
					<Box display="flex" maxWidth="100%" height="100%" alignItems="center" justifyContent="center" columnGap={0.5}>
						{hasRemark && (
							<IconButton onClick={(e) => onRemarkClick(e, row)} size="small" color="warning">
								<InfoRounded fontSize="small" />
							</IconButton>
						)}
						<Box
							display="flex"
							width="100%"
							alignItems="center"
							height={"22px"}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "6px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}
							<Typography pl="3px" width="100%" overflow="hidden" textOverflow="ellipsis">
								{statusOptions[row.status]?.name ?? "----"}
							</Typography>
						</Box>
					</Box>
				);
			else if (disableBtnVal)
				return (
					<Box display="flex" width="100%" height="100%" alignItems="center" justifyContent="center" columnGap={0.5}>
						{hasRemark && (
							<IconButton onClick={(e) => onRemarkClick(e, row)} size="small" color="warning">
								<InfoRounded fontSize="small" />
							</IconButton>
						)}
						<Box
							display="flex"
							alignItems="center"
							height={"22px"}
							sx={{
								backgroundColor: statusOptions[row.status]?.color || yellow[400],
								color: "white",
								padding: "6px",
								borderRadius: "5px",
							}}>
							{statusOptions[row.status]?.icon}
							<Typography pl="3px">{statusOptions[row.status]?.name ?? "----"}</Typography>
						</Box>
					</Box>
				);
			else
				return (
					<Box display="flex" alignItems="center" columnGap={0.5}>
						{hasRemark && (
							<IconButton onClick={(e) => onRemarkClick(e, row)} size="small" color="warning">
								<InfoRounded fontSize="small" />
							</IconButton>
						)}
						<Button
							onClick={(e) => publishFun(e, row)}
							variant="contained"
							size="small"
							sx={{ textTransform: "capitalize" }}
							startIcon={<Publish />}>
							Publish
						</Button>
					</Box>
				);
		},
	};
};
